<template>
  <EditableBox
    ref="editableBox"
    :mode="mode"
    :position="position"
    :includeBtns="type == 'editor' && !noMergeEditBtns ? mergeGlobalBtns(includeBtns) : includeBtns"
    :hideHover="hideHover"
    @onMore="handleMore"
    @onEdit="handelEdit"
    @onAdd="handleAdd"
    @onDelete="handleDelete"
    @onConfirm="hanldeConfirm"
  >
    <template slot-scope="{ isEdit }">
      <!-- 编辑 -->
      <template v-if="isEdit">
        <!-- 基础文本 -->
        <base-input v-if="type === 'input'" v-model="inputValue"></base-input>
        <!-- 富文本编辑器 -->
        <editor-input v-else :image-style="imageStyle" v-model="inputValue" @onButtonExec="handleEditorButtonExec">
          <template v-if="isShowButtonComp">
            <rich-text-dialog
              ref="richTextDialog"
              :mode="mode"
              :editorData="value"
              @onChange="hanldeChangeEditorData"
            ></rich-text-dialog>
            <rich-text-popover
              ref="richTextPopover"
              :mode="mode"
              :editorData="value"
              @onChange="hanldeChangeEditorData"
            ></rich-text-popover>
          </template>
        </editor-input>
      </template>

      <!-- 展示 -->
      <template v-else>
        <!-- 富文本内容 -->
        <render-html v-if="isEditorValue" @onButtonExec="handleButtonExec" :editor-data="value.data">
          <template v-if="isShowButtonComp">
            <rich-text-dialog
              ref="richTextDialog"
              :mode="mode"
              :editorData="value"
              @onChange="hanldeChangeEditorData"
            ></rich-text-dialog>
            <rich-text-popover
              ref="richTextPopover"
              :mode="mode"
              :editorData="value"
              @onChange="hanldeChangeEditorData"
            ></rich-text-popover>
          </template>
        </render-html>
        <!-- 其他内容 -->
        <span v-else>
          <slot></slot>
        </span>
      </template>
    </template>
  </EditableBox>
</template>

<script>
// components
import EditableBox from "../EditableBox/index.jsx";
import BaseInput from "../BaseInput";
import EditorInput from "../EditorInput";
import RenderHtml from "@/views/editor/simple-editor/RenderHtml.jsx";
import RichTextDialog from "./RichTextDialog";
import RichTextPopover from "./RichTextPopover";
import { markEditorNumberColor } from "./util";

export default {
  name: "TextBox",
  components: {
    EditableBox,
    BaseInput,
    EditorInput,
    RenderHtml,
    RichTextDialog,
    RichTextPopover
  },
  props: {
    mode: String,
    type: {
      type: String,
      default: "input"
    },
    value: {
      type: [String, Object],
      default: ""
    },
    position: String,
    imageStyle: {
      type: Object,
      default: () => ({})
    },
    includeBtns: {
      type: Array,
      default: () => ["confirm", "edit"]
    },
    hideHover: {
      type: Boolean,
      default: false
    },
    noMergeEditBtns: Boolean
  },
  data() {
    return {
      inputValue: this.value,
      isShowButtonComp: false
    };
  },
  computed: {
    isEditorValue() {
      return typeof this.value !== "string" && this.value.type && this.value.type === "simpleEditor";
    }
  },
  watch: {
    value(val) {
      this.inputValue = val;
    }
  },

  mounted() {},

  methods: {
    handleMore(command, color) {
      if (command === "markEditorNumberColor") {
        if (this.type === "editor" && this.isEditorValue) {
          let editorData = JSON.parse(JSON.stringify(this.value));
          editorData = markEditorNumberColor(editorData, color);
          this.$emit("onChange", editorData);
        } else {
          this.$message("非富文本内容，无效操作！");
        }
      }
    },
    mergeGlobalBtns(includeBtns) {
      let btns = [];
      let hasMore = false;
      includeBtns.forEach(item => {
        if (Array.isArray(item)) {
          hasMore = true;
          btns.push([...item, "markEditorNumberColor"]);
        } else {
          btns.push(item);
        }
      });
      if (!hasMore) {
        btns.push(["markEditorNumberColor"]);
      }
      return btns;
    },
    handelEdit() {},
    handleAdd() {
      this.$emit("onAdd");
    },
    handleDelete() {
      this.$emit("onDelete");
    },
    hanldeConfirm() {
      this.$emit("onChange", this.inputValue);
    },
    handleEditorButtonExec(key, id, data) {
      this.$refs.editableBox.handleConfirm();
      this.handleButtonExec(key, id, data);
    },
    handleButtonExec(key, id, data) {
      this.isShowButtonComp = true;
      setTimeout(() => {
        if (key === "RICH_TEXT_DIALOG") {
          this.$refs.richTextDialog.open(id, data);
        } else if (key === "RICH_TEXT_POPOVER") {
          this.$refs.richTextPopover.open(id, data);
        }
      }, 100);
    },
    hanldeChangeEditorData(data) {
      this.$emit("onChange", data);
    },
    openEdit() {
      this.$refs.editableBox.setIsEdit(true);
    }
  }
};
</script>

<style lang="less" scoped></style>
